const API_URL = process.env.REACT_APP_API_URL!

const AppRoutes = {
  root: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  contacts: '/dashboard/contacts',
  appointments: '/dashboard/appointments',
  products: '/dashboard/products',
  sales: '/dashboard/sales',
  templates: '/dashboard/templates',
  automations: '/dashboard/automations',
  editTemplateRoot: '/dashboard/templates/edit',
  editTemplate: '/dashboard/templates/edit/:id',
  updateAutomationRoot: '/dashboard/automations/update',
  updateAutomation: '/dashboard/automations/update/:id',
  contactProfile: '/dashboard/contacts/profile/:id',
  settings: '/dashboard/settings',
  appointmentSettings: '/dashboard/settings/appointments',
  integrationSettings: '/dashboard/settings/integrations',
  teamSettings: '/dashboard/settings/team',
  billing: '/dashboard/settings/billing',
  home: '/dashboard',
  websiteBuilder: '/dashboard/website-builder',
  notFound: '*',
}

const DateTimeFormats = {
  DefaultDate: 'YYYY-MM-DD',
}

export { API_URL, AppRoutes, DateTimeFormats }
